import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c(VDataTable, {
        key: _vm.keyTable,
        staticClass: "text-center table-inca",
        attrs: {
          responsive: "",
          dense: "",
          items: _vm.baseItems,
          headers: _vm.baseHeaders,
          "hide-default-footer": "",
          "items-per-page": _vm.pagination.base.limit,
          page: _vm.pagination.base.current,
        },
        on: {
          pagination: function ($event) {
            _vm.pagination.base.total = $event.itemsLength
          },
          "update:page": function ($event) {
            return _vm.$set(_vm.pagination.base, "current", $event)
          },
        },
        scopedSlots: _vm._u([
          {
            key: "item.source_table",
            fn: function (ref) {
              var item = ref.item
              return [
                _vm._v(" " + _vm._s(_vm.stripRlink(item.source_table)) + " "),
              ]
            },
          },
          {
            key: "item.dest_table",
            fn: function (ref) {
              var item = ref.item
              return [
                _vm._v(" " + _vm._s(_vm.stripRlink(item.dest_table)) + " "),
              ]
            },
          },
          {
            key: "item.creation_date",
            fn: function (ref) {
              var item = ref.item
              return [
                _c(VIcon, [_vm._v("mdi-calendar")]),
                _vm._v(
                  " " +
                    _vm._s(_vm.getDateAndHours(item.creation_date).date) +
                    " "
                ),
                _c(VIcon, [_vm._v("mdi-clock-outline")]),
                _vm._v(
                  " " +
                    _vm._s(_vm.getDateAndHours(item.creation_date).hour) +
                    " "
                ),
              ]
            },
          },
          {
            key: "item.expiration_date",
            fn: function (ref) {
              var item = ref.item
              return [
                _c(VIcon, [_vm._v("mdi-calendar")]),
                _vm._v(
                  " " +
                    _vm._s(
                      item.expiration_date
                        ? _vm.getDateAndHours(item.expiration_date).date
                        : "-"
                    ) +
                    " "
                ),
              ]
            },
          },
          {
            key: "item.status_id",
            fn: function (ref) {
              var item = ref.item
              return [
                _c(
                  VChip,
                  {
                    attrs: {
                      small: "",
                      "text-color": _vm.getUseCaseStatus(item.status_id)
                        .textColor,
                      color: _vm.getUseCaseStatus(item.status_id).color,
                    },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(_vm.getUseCaseStatus(item.status_id).status) +
                        " "
                    ),
                  ]
                ),
              ]
            },
          },
        ]),
      }),
      _c("pagination-vue", { attrs: { pagination: _vm.pagination.base } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }